import { createSupabaseClient, type SupabaseClient } from '@viet-parenting/supabase';

export const supabase: SupabaseClient = createSupabaseClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
